import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal, formatToFractional } from '../../../controls/conversions';

// BrickmouldHeight — text input, shown only when Brickmould = Installed
// Must be >= frameHeight
const BrickmouldHeight = ({ value = { value: '', label: '' }, onChange, disabled = false, frameHeight }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const [error,    setError]    = useState('');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const validate = (v) => {
    if (!v) { setError(''); return; }
    const num = parseFloat(formatToDecimal(v));
    const min = frameHeight?.value ? parseFloat(formatToDecimal(frameHeight.value)) : null;
    if (!isNaN(num) && min !== null && num < min) {
      setError(`Brickmould Height must be ≥ Frame Height (${frameHeight.value})`);
    } else {
      setError('');
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setSelected(v);
    validate(v);
  };

  const handleFocus = (e) => {
    const dec = formatToDecimal(e.target.value);
    setSelected(dec === '0' || dec === 0 ? '' : dec);
  };

  const handleBlur = (e) => {
    const formatted = formatToFractional(e.target.value);
    setSelected(formatted);
    onChange({ value: formatted, label: formatted });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdBrickmouldHeight">Brickmould Height</label>
      <input
        id="SdBrickmouldHeight"
        value={selected}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder="e.g. 84&quot;"
      />
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default BrickmouldHeight;
